module.exports = __webpack_public_path__ + "img/greyCross.bf263e25.svg";